import {createListenerMiddleware} from '@reduxjs/toolkit';
import {setStoreInitalized} from './operatingModel/operatingModelSlice';
import {setAuthToken} from './auth/authSlice';
import store from '.';
import {omApi} from './operatingModel/operatingModelApi';
import {userApi} from './users/userApiSlice';
import {artifactsApi} from './artifacts/artifactsApi';
import {changeApi} from './change/changeApi';
import {setLatestRelease} from './change/changeSlice';
import {setSelectedReleases} from './appState/appStateSlice';
import {setProcessesWithMultipleModels} from './operatingModel/operatingModelSlice';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: setAuthToken,
  effect: async (action, listenerApi) => {
    listenerApi.cancelActiveListeners();
    console.log('user auth token received: ' + (action.payload != null));

    const storeInit = listenerApi.getState().operatingModel.storeInitalized;
    const user = listenerApi.getState().auth.userProfile;
    const selectedReleases = listenerApi.getState().appState.selectedReleases;

    // Forces user record is created if this is the first time user logs into the application
    // from Okta
    await EnsureUserExists(user, listenerApi);

    if (storeInit && user) {
      store.dispatch(userApi.endpoints.getUserByEmail.initiate(user.email, {forceRefetch: true}));
      console.log('store already initalized, stop listening');
      listenerApi.unsubscribe();
    } else if (action.payload) {
      console.log('store operatingModel fetching from API...');
      store.dispatch(omApi.endpoints.getAllOpModels.initiate());
      store.dispatch(omApi.endpoints.getAllPhases.initiate());
      store.dispatch(omApi.endpoints.getAllTrainings.initiate());
      store.dispatch(artifactsApi.endpoints.getAllArtifacts.initiate());
      store.dispatch(artifactsApi.endpoints.getMasterSOP.initiate());
      store.dispatch(omApi.endpoints.getAllRoles.initiate());
      store.dispatch(omApi.endpoints.getAllProcesses.initiate());
      store.dispatch(omApi.endpoints.getMilestones.initiate());
      store.dispatch(omApi.endpoints.getAllMaps.initiate());
      store.dispatch(userApi.endpoints.getUserByEmail.initiate(user.email, {forceRefetch: true}));
      store.dispatch(changeApi.endpoints.getAllReleases.initiate());

      await setProcesses(listenerApi);
      await fetchChanges(selectedReleases, listenerApi);

      store.dispatch(setStoreInitalized(true));
    } else {
      console.log('skipping store initialization');
    }
  },
});

async function setProcesses(listenerApi) {
  if (await listenerApi.condition(omApi.endpoints.getAllProcesses.matchFulfilled)) {
    const allProccesses = listenerApi.getState().operatingModel.allProcesses;
    if (allProccesses) {
      store.dispatch(setProcessesWithMultipleModels(allProccesses.filter((p) => p.parent_process !== null)));
    }
  }
}

async function fetchChanges(selectedReleases, listenerApi) {
  if (await listenerApi.condition(changeApi.endpoints.getAllReleases.matchFulfilled)) {
    const lr = listenerApi.getState().changes.allReleases.at(0);
    if (lr) {
      store.dispatch(setLatestRelease(lr));
      store.dispatch(changeApi.endpoints.getNewProcesses.initiate(lr.release));
      if (selectedReleases?.length === 0 || !selectedReleases) {
        store.dispatch(setSelectedReleases([lr.release]));
      } else {
        store.dispatch(changeApi.endpoints.getChangesByRelease.initiate(selectedReleases));
      }
    }
  }
}

async function EnsureUserExists(user, listenerApi) {
  store.dispatch(userApi.endpoints.getUserByEmail.initiate(user.email, {forceRefetch: true}));
  if (
    (await listenerApi.condition(userApi.endpoints.getUserByEmail.matchFulfilled)) ||
    (await listenerApi.condition(userApi.endpoints.getUserByEmail.matchRejected))
  ) {
    const userID = listenerApi.getState().user.user.id;
    // create a new user record if no valid user record exists
    if (userID < 0) {
      store.dispatch(
        userApi.endpoints.createUser.initiate({
          email: user.email,
          first_name: user.firstName,
          last_name: user.lastName,
          time_zone: user.timeZone,
          last_login_dt: Date.now(),
          permission: 'user',
        }),
      );

      if (
        (await listenerApi.condition(userApi.endpoints.createUser.matchFulfilled)) ||
        (await listenerApi.condition(userApi.endpoints.createUser.matchRejected))
      ) {
        store.dispatch(userApi.endpoints.getUserByEmail.initiate(user.email, {forceRefetch: true}));
      }
    }
  }
}
